import React, { memo } from "react";
import { ConfigProvider } from "antd";
import { Routes as ReactRoutesDom, Route } from "react-router-dom";
import App from './../App.js'
import Login from "../components/login/Login.js";
import NotFound from "../components/notFound/notFound.js";

function Routes() {
    return (
        <ConfigProvider>
            <ReactRoutesDom>
                <Route exact path="/" element={<App />} />
                <Route exact path="/user-list" element={<App />} />
                <Route exact path="/amlak-list" element={<App />} />
                <Route exact path="/notification" element={<App />} />
                <Route exact path="/operators" element={<App />} />
                <Route exact path="/settings" element={<App />} />
                <Route exact path="/versions" element={<App />} />
                <Route exact path="/about-us" element={<App/>}/>
                <Route exact path="/logout" element={<App/>}/>
                <Route exact path="/login" element={<Login />} />
                <Route path="*" element={<NotFound/>}/>
            </ReactRoutesDom>
        </ConfigProvider>
    );
}
export default memo(Routes);
